/**
 *
 * ModelScaleModal
 *
 */


// var sw = require('./../sw');
var ShapewaysFormView = require('./ShapewaysFormView');
var $ = require('./../../sw-jquery/sw-jquery');

var ModelScaleModal = ShapewaysFormView.extend({

  events: {
    'click [data-sw-model-scaling-modal-save]': 'saveScale',
    'click [data-sw-model-scaling-modal-cancel]': 'cancelScale',
    'keyup [data-sw-model-axis-scale]' : 'onAxisChanged',
    'blur [data-sw-model-axis-scale]' : 'onAxisBlur',
    'change [data-sw-model-scale-modal-unit-selector]' : 'onUnitsChanged',
    'submit': 'onSubmit'
  },

  initialize: function(options) {
    // Eventually we want to make a 3d Model Backbone Model
    this.modelId = options.modelId;
    this.minBound = options.minBound  / 1000;//convert to meters from millimeters
    this.maxBound = options.maxBound  / 1000;//convert to meters from millimeters
    this.origin = options.origin;

    this.cacheElements();
    this.initValues();

    this.displayAxis();
    this.checkAxisValues();
  },

  cacheElements: function() {
    this.$scaleInputX = $('[data-sw-model-axis-scale="x"]');
    this.$scaleInputY = $('[data-sw-model-axis-scale="y"]');
    this.$scaleInputZ = $('[data-sw-model-axis-scale="z"]');
    this.$scaleInputP = $('[data-sw-model-axis-scale="p"]');
    this.$unitSelector = $('[data-sw-model-scale-modal-unit-selector]');
    this.$noticeTooSmall = $('[data-sw-model-scale-modal-notice-too-small]');
    this.$noticeTooLarge = $('[data-sw-model-scale-modal-notice-too-large]');
    this.$noticePercentage = $('[data-sw-model-scale-modal-percentage-error]');
    this.$noticeFileIsTooBig = $('[data-sw-model-scale-modal-file-size-too-big-error]');
    this.$saveButton = $('[data-sw-model-scaling-modal-save]');
  },

  initValues: function() {
    var axis = this.convertToMeters(this.getInputAxisScales(), this.$unitSelector.val());
    this.scaleX = axis.x;
    this.scaleY = axis.y;
    this.scaleZ = axis.z;
    this.scaleP = this.$scaleInputP.val();
    this.originalScaleX = this.scaleX;
    this.originalScaleY = this.scaleY;
    this.originalScaleZ = this.scaleZ;
    this.originalScaleP = this.scaleP;
    this.currentUnit = this.$unitSelector.val();
  },

  saveScale: function(e) {
    e.preventDefault();

    if(!this.checkAxisValues() && !this.$saveButton.hasClass('waiting')) {
      return;
    }

    var data = {
      modelId : this.modelId,
      scale : this.$unitSelector.val(),
      rescale : this.scaleP,
      origin : this.origin
    };

    this.$saveButton.addClass('waiting');

    var self = this;

    $.ajax({
      type: 'POST',
      url: '/model/edit/scale',
      dataType: 'json',
      data: data,
      complete: function(response) {
        response = window.JSON.parse(response.responseText);
        if(response.success) {
          self.$saveButton.removeClass('btn--disabled');
          $('#uploaderButton' + this.modelId).removeClass('btn--disabled');
          window.location.replace(response.redirectUrl);
        } else {
          self.$saveButton.removeClass('waiting');
        }
      },
      error: function() {
          self.fileIsTooBig();
          self.$saveButton.removeClass('waiting');
          self.$saveButton.addClass('disabled');
      }
    });
  },

  onAxisChanged: function(e) {
    var $el = $(e.target);
    var axisChanged = $el.data('swModelAxisScale');
    var newAxis = this.convertToMeters(this.getInputAxisScales(), this.$unitSelector.val());
    newAxis.p = parseFloat(this.$scaleInputP.val());

    var ratio = 0;

    switch(axisChanged) {
      case 'x':
        if(newAxis.x && newAxis.x !== this.scaleX) {
          ratio = newAxis.x / this.originalScaleX;
        }
        break;
      case 'y':
        if(newAxis.y && newAxis.y !== this.scaleY) {
          ratio = newAxis.y / this.originalScaleY;
        }
        break;
      case 'z':
        if(newAxis.z && newAxis.z !== this.scaleZ) {
          ratio = newAxis.z / this.originalScaleZ;
        }
        break;
      case 'p':
        if(newAxis.p !== this.scaleP) {
          if(!newAxis.p || newAxis.p <= 0) {
            this.applyRatio(0, axisChanged);
          }
          ratio = newAxis.p / this.originalScaleP;
        }
    }

    if(ratio) {
      this.applyRatio(ratio, axisChanged);
    }

    this.checkAxisValues();
  },

  onAxisBlur: function() {
    this.displayAxis();
  },

  applyRatio: function(ratio, ignoreAxis) {
    this.scaleX = this.originalScaleX * ratio;
    this.scaleY = this.originalScaleY * ratio;
    this.scaleZ = this.originalScaleZ * ratio;
    this.scaleP = this.originalScaleP * ratio;
    this.displayAxis(ignoreAxis);
  },

  onUnitsChanged: function() {
    var newUnit = this.$unitSelector.val();
    var newAxis = this.convertToMeters(this.getInputAxisScales(), newUnit);

    this.scaleP = this.getNewPercentage(newUnit);

    this.scaleX = newAxis.x;
    this.scaleY = newAxis.y;
    this.scaleZ = newAxis.z;
    this.displayAxis();
    this.checkAxisValues();
  },

  getNewPercentage: function(newUnit) {

    var percInM = null;
    var newPercentage = 0;

    switch(this.currentUnit) {
      case 'mm':
        percInM = this.scaleP * 1000;
        break;
      case 'cm':
        percInM = this.scaleP * 100;
        break;
      case 'm':
        percInM = this.scaleP * 1;
        break;
      case 'in':
        percInM = this.scaleP * 39.370;
        break;
    }

    switch (newUnit) {
      case 'mm':
        newPercentage = percInM / 1000;
        break;
      case 'cm':
        newPercentage = percInM / 100;
        break;
      case 'm':
        newPercentage = percInM / 1;
        break;
      case 'in':
        newPercentage = percInM / 39.370;
        break;
    }

    this.currentUnit = newUnit;
    return newPercentage;
  },

  checkAxisValues: function() {
    this.clearNotice();
    var error = false;

    if(this.scaleP <= 0) {
      this.percentageNotice();
      error = true;
    }

    //Too Large
    if(this.scaleX > this.maxBound) {
      this.axisNoticeLarge(this.$scaleInputX);
      error = true;
    }

    if(this.scaleY > this.maxBound) {
      this.axisNoticeLarge(this.$scaleInputY);
      error = true;
    }

    if(this.scaleZ > this.maxBound) {
      this.axisNoticeLarge(this.$scaleInputZ);
      error = true;
    }

    //Too Small
    if(this.scaleX < this.minBound) {
      this.axisNoticeSmall(this.$scaleInputX);
      error = true;
    }

    if(this.scaleY < this.minBound) {
      this.axisNoticeSmall(this.$scaleInputY);
      error = true;
    }

    if(this.scaleZ < this.minBound) {
      this.axisNoticeSmall(this.$scaleInputZ);
      error = true;
    }

    if(!error) {
      this.$saveButton.removeClass('disabled');
    }
    else {
      this.$saveButton.addClass('disabled');
    }

    return !error;
  },

  convertToMeters: function(axisScales, units) {
    switch (units) {
      case 'mm':
        return this.scaleUp(axisScales, 1000);
      case 'cm':
        return this.scaleUp(axisScales, 100);
      case 'm':
        return this.scaleUp(axisScales, 1);
      case 'in':
        return this.scaleUp(axisScales, 39.370);
    }

  },

  scaleDown: function(axisScales, unit) {
    axisScales.x *= unit;
    axisScales.y *= unit;
    axisScales.z *= unit;
    axisScales.p *= unit;

    return axisScales;
  },

  scaleUp: function(axisScales, unit) {
    axisScales.x /= unit;
    axisScales.y /= unit;
    axisScales.z /= unit;
    axisScales.p /= unit;

    return axisScales;
  },

  axisNoticeSmall: function(axis) {
    axis.addClass('notice');
    this.$noticeTooSmall.removeClass('hidden');
  },

  axisNoticeLarge: function(axis) {
    axis.addClass('notice');
    this.$noticeTooLarge.removeClass('hidden');
  },

  percentageNotice: function() {
    this.$scaleInputP.addClass('error');
    this.$noticePercentage.removeClass('hidden');
  },

  fileIsTooBig: function() {
    this.$noticeFileIsTooBig.removeClass('hidden');
  },

  clearNotice: function() {
    this.$noticePercentage.addClass('hidden');
    this.$noticeTooSmall.addClass('hidden');
    this.$noticeTooLarge.addClass('hidden');
    this.$scaleInputX.removeClass('notice');
    this.$scaleInputY.removeClass('notice');
    this.$scaleInputZ.removeClass('notice');
    this.$scaleInputP.removeClass('error');
  },

  displayAxis: function(ignoreAxis) {
    var units = this.$unitSelector.val();
    var axisScales = this.getAxisScales();
    var newScales = null;

    switch (units) {
      case 'mm':
        newScales = this.scaleDown(axisScales, 1000);
        break;
      case 'cm':
        newScales = this.scaleDown(axisScales, 100);
        break;
      case 'm':
        newScales = this.scaleDown(axisScales, 1);
        break;
      case 'in':
        newScales = this.scaleDown(axisScales, 39.370);
        break;
    }

    if(ignoreAxis !== 'x'){
      this.$scaleInputX.val(newScales.x.toFixed(2));
    }
    if(ignoreAxis !== 'y') {
      this.$scaleInputY.val(newScales.y.toFixed(2));
    }
    if(ignoreAxis !== 'z') {
      this.$scaleInputZ.val(newScales.z.toFixed(2));
    }
    if(ignoreAxis !== 'p') {
      this.$scaleInputP.val(parseFloat(this.scaleP).toFixed(0));
    }



  },

  getAxisScales: function() {
    return {
      x : this.scaleX,
      y : this.scaleY,
      z : this.scaleZ,
      p : this.scaleP
    };
  },

  getInputAxisScales: function() {
    return {
      x : this.$scaleInputX.val(),
      y : this.$scaleInputY.val(),
      z : this.$scaleInputZ.val(),
      p : this.$scaleInputP.val()
    };
  },

  cancelScale: function() {
    $.fancybox.close();
  }

});

module.exports = ModelScaleModal;
